export default function InvitationsController() {}
